module.exports = __webpack_public_path__ + "static/media/namith.5916cd31.jpeg";